import { Category, ICategory, Icon } from 'components';
import { FC, ReactNode, useState } from 'react';
import { ItemType } from 'types';
import cn from 'classnames';

import reportPlaceholder from 'assets/sprite/report-placeholder.svg';
import videoPlaceholder from 'assets/sprite/video-placeholder.svg';
import arrow from 'assets/sprite/arrow.svg';

import styles from './Library.module.scss';
import { useTranslation } from 'react-i18next';

export interface ILibrary {
  title: string;
  categories: ICategory[];
  type: ItemType;
  libraries?: ILibrary[];
  children?: ReactNode;
}

export const Library: FC<ILibrary> = ({ title, categories, type, children }) => {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState(true);

  const handleClick = () => setIsActive(!isActive);

  const getPlaceholderType = () => {
    if (type === ItemType.Report) {
      return (
        <Icon
          id={reportPlaceholder.id}
          viewBox={reportPlaceholder.viewBox}
          className={styles.placeholderIco}
        />
      );
    }
    return (
      <Icon
        id={videoPlaceholder.id}
        viewBox={videoPlaceholder.viewBox}
        className={styles.placeholderIco}
      />
    );
  };

  return (
    <div className={styles.root}>
      <div
        role={'button'}
        onClick={handleClick}
        className={cn(styles.head, { [styles.isActive]: isActive, [styles.isInactive]: !isActive })}
      >
        <span className={styles.title}>{t(title)}</span>
        <div className={styles.arrow}>
          <Icon id={arrow.id} viewBox={arrow.viewBox} className={styles.ico} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.placeholder}>{getPlaceholderType()}</div>
        <div className={styles.inner}>
          {categories.map((category, index) => {
            return (
              <Category key={index} items={category.items} title={category.title} type={type} />
            );
          })}
        </div>
        <div className={styles.sub}>{children}</div>
      </div>
    </div>
  );
};
